/* (ignored) */


//////////////////
// WEBPACK FOOTER
// jsdom (ignored)
// module id = 344
// module chunks = 0